module.exports = __webpack_public_path__ + "img/mca-logo-btn.4e4fad26.webp";